module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00285.f5791cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00285.png
// module id = 1015
// module chunks = 0